// -----------------------------------------
// -------- GENERATED FROM .FX FILE --------
// -----------------------------------------
// Source: src/babylon/shaders/outline_id_map_generation.fragment.fx
import { ShaderStore } from '@inter-ikea-betrakta-babylonjs/core/Engines/shaderStore.js';
const name = 'outline_id_map_generationPixelShader';
const shader = `#ifdef INSTANCES
varying vec4 vOutlineColor;
#else
uniform vec4 uOutlineColor;
#endif
void main(void)
{
#ifdef INSTANCES
gl_FragColor = vOutlineColor;
#else
gl_FragColor = uOutlineColor;
#endif
}`;
// Sideeffect
ShaderStore.ShadersStore[name] = shader;
// eslint-disable-next-line @typescript-eslint/naming-convention
export const outline_id_map_generationPixelShader = { name, shader };
//# sourceMappingURL=outline_id_map_generation.fragment.js.map